var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "faq--question",
        { "faq--question-show-content": _vm.showContent }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "faq--question-icon" },
        [_c("Icon", { attrs: { icon: "question-mark" } })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "faq--question-title" }, [
        _c(
          "a",
          {
            attrs: { href: "#" },
            on: {
              click: function($event) {
                $event.preventDefault()
                _vm.showContent = !_vm.showContent
              }
            }
          },
          [
            _c("div", { staticClass: "faq--question-title-text" }, [
              _vm._v(_vm._s(_vm.title))
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showContent
        ? _c(
            "div",
            { staticClass: "faq--question-content" },
            [
              _vm._t("default"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "faq--question-feedback" },
                [
                  _vm.gaveFeedback
                    ? _c("div", { staticClass: "success" }, [
                        _vm._v("Vielen Dank!")
                      ])
                    : [
                        _c("div", [
                          _vm._v(
                            "\n\t\t\t\t\tWar diese Antwort hilfreich?\n\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "faq--question-feedback-buttons" },
                          [
                            _c(
                              "div",
                              [
                                _c("Button", {
                                  attrs: {
                                    text: "Ja",
                                    smaller: "",
                                    secondary: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.feedback(true)
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("Button", {
                                  attrs: {
                                    text: "Nein",
                                    smaller: "",
                                    secondary: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.feedback(false)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ]
                ],
                2
              )
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }